import React, { useState, useEffect } from 'react';
import '../../styles/timesheetStyles/TimeSheets.css';
import { fetchUserData } from '../../services/API'
import { useNavigate } from 'react-router-dom';
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import { getTimesheetData } from "../../services/API";

const TimeSheets = () => {
  const [activeTab, setActiveTab] = useState('Employee');
  const [selectedMembers, setSelectedMembers] = useState({});
  const [view, setView] = useState('Week'); 
  const [selectedYear, setSelectedYear] = useState(2024);
  const [selectedMonth, setSelectedMonth] = useState('January');
  const [days, setDays] = useState([]);
  const [weeks, setWeeks] = useState([]);
  const [currentDayIndex, setCurrentDayIndex] = useState(0); 
  const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0); 
  const [employeeData, setEmployeeData] = useState([]);
  const [serviceCalls, setServiceCalls] = useState([]);
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  const [currentRow, setCurrentRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const rowsToDisplay = currentRow.slice(indexOfFirstRow, indexOfLastRow); 
  const totalPages = Math.ceil(currentRow.length / rowsPerPage); 

  const handleCheckboxChange = (name) => {
    setSelectedMembers((prevSelectedMembers) => ({
      ...prevSelectedMembers,
      [name]: !prevSelectedMembers[name],
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getTimesheetData();
        setServiceCalls(data.serviceCalls);
        setProjects(data.projects);
        console.log("Data timesheet.js " , data);
      } catch (error) {
        console.error("Error loading timesheet data:", error);
      }
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTimesheetData();
      const combinedRows = [...data.serviceCalls, ...data.projects];
      setCurrentRow(combinedRows);
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchUserData();
        console.log('Employee names:', response.data);

        // Filter out employees based on Job_Title
        const employees = response.data.filter(user => user.Job_Title === 'Employee');
        console.log('Filtered employees:', employees);

        setEmployeeData(employees);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
  },[]);

  const redirectToTimesheetDetails = () => {
    navigate('/timesheetdetails');
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    updateDaysAndWeeks(`${month} ${selectedYear}`);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
 
  const renderPageNumbers = () => {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        pageNumbers.push(
          <button key={i} onClick={() => handlePageChange(i)} className={`page-number ${currentPage === i ? 'active' : ''}`} >
            {i}
          </button>
        );
      } else if (
        (i === currentPage - 2 && currentPage > 3) ||
        (i === currentPage + 2 && currentPage < totalPages - 2)
      ) {
        pageNumbers.push(<span key={i} className="dots">...</span>);
      }
    }
    return pageNumbers;
  };

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const years = [2024, 2025, 2026, 2027, 2028, 2029, 2030]; 

  const handleYearChange = (event) => {
    const year = parseInt(event.target.value); 
    setSelectedYear(year); 
    updateDaysAndWeeks(`${selectedMonth} ${year}`); 
  };

  const updateDaysAndWeeks = (monthYear) => {
    console.log(`Updating days and weeks for: ${monthYear}`);
  
    const monthDays = {
      'January': 31,
      'February': 29, // Leap year
      'March': 31,
      'April': 30,
      'May': 31,
      'June': 30,
      'July': 31,
      'August': 31,
      'September': 30,
      'October': 31,
      'November': 30,
      'December': 31,
    };
  
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  
    // Parse the current month and year
    let [currentMonth, currentYear] = monthYear.split(" ");
    let currentMonthIndex = months.indexOf(currentMonth);
    let daysArray = [];
  
    const populateDaysForMonth = (month, year) => {
      const daysInMonth = monthDays[month];
      for (let i = 1; i <= daysInMonth; i++) {
        daysArray.push({ day: i, fullDate: `${i} ${month}` });
      }
    };
  
    // Start filling days for the current month
    populateDaysForMonth(currentMonth, currentYear);
  
    // Continue filling days for next months till December 31
    let nextMonthIndex = currentMonthIndex + 1;
    let nextYear = currentYear;
    while (daysArray.length < 366) {  // Maximum days in a leap year
      if (nextMonthIndex === 12) {
        nextMonthIndex = 0;
        nextYear = parseInt(nextYear) + 1; // Increment year after December
      }
      const nextMonth = months[nextMonthIndex];
      populateDaysForMonth(nextMonth, nextYear);
      nextMonthIndex++;
    }
  
    // Generate weeks as ranges of 7 days
    const weeksArray = [];
    for (let i = 0; i < daysArray.length; i += 7) {
      const startDay = daysArray[i].fullDate;
      const endDay = daysArray[Math.min(i + 6, daysArray.length - 1)].fullDate;
      weeksArray.push(`${startDay} - ${endDay}`);
    }
  
    // Update state with only day numbers for display
    const daysForDisplay = daysArray.map(day => day.day);
  
    setDays(daysForDisplay); // This will only display the day numbers
    setWeeks(weeksArray); // This will still show full date ranges (like "1 January - 7 January")
  };
  
  
  
  
const handleViewChange = (newView) => {
  setView(newView);
  if (newView === 'Day') {
    setCurrentDayIndex(0);
  } else if (newView === 'Week') {
    setCurrentWeekIndex(0); // Reset to the first week
  } else if (newView === 'Month') {
    setCurrentMonthIndex(0);
  }
  updateDaysAndWeeks(`${selectedMonth} ${selectedYear}`);
};

  useEffect(() => {
    updateDaysAndWeeks(`${selectedMonth} ${selectedYear}`);
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    updateDaysAndWeeks(`${selectedMonth} ${selectedYear}`);
  }, [selectedMonth, selectedYear]);

  const scrollDays = (direction) => {
    const totalDays = days.length; 
    setCurrentDayIndex((prevIndex) => {
      const newIndex = prevIndex + direction * 10; 
      return Math.max(0, Math.min(newIndex, totalDays - 10)); 
    });
  };

  const scrollWeeks = (direction) => {
    setCurrentWeekIndex((prevIndex) => {
      const totalWeeks = weeks.length;
      const newIndex = prevIndex + direction * 4; // Move by 4 weeks at a time
      return Math.max(0, Math.min(newIndex, totalWeeks - 4)); // Ensure the index stays within bounds
    });
  };

  

  const scrollMonths = (direction) => {
    const totalMonths = months.length;
    setCurrentMonthIndex((prevIndex) => {
      const newIndex = prevIndex + direction * 1; // Move by 1 month at a time
      return Math.max(0, Math.min(newIndex, totalMonths - 1)); // Ensure index is within bounds
    });
  };
  

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'Project') {
      navigate('/timesheetproject'); 
    }
  };

  return (
    <div className="timesheet-container">
      
      <Header />

      <div className="content">
        <div className="tabs-container">
          <h2 className="tabs-title">TimeSheets</h2>
          <div className="tabs">
            <button className={`tab-item ${activeTab === 'Employee' ? 'active' : ''}`} onClick={() => setActiveTab('Employee')} >
              Employee
            </button>
            <button className={`tab-item ${activeTab === 'Project' ? 'active' : ''}`} onClick={() => handleTabClick('Project')}> Project </button>
          </div>
        </div>
      </div>

      <div className="timesheetScreen">
        
        <div className="team-container">
          <div className="team-title-container">
            <div className="team-title">Team</div>
            <img src="/images/search.svg"  alt="Search"  className="search-icon"  /> 
        </div>
          
        <div className="team-list">
          {activeTab === "Employee" &&
            employeeData.map((member) => (
              <div className="team-member" key={member.Email}>
                <img
                  src={
                    selectedMembers[member.Email]
                      ? "../images/checkbox-checked.png"
                      : "../images/checkbox-unchecked.png"
                  }
                  alt={selectedMembers[member.Email] ? "Checked" : "Unchecked"}
                  className="member-icon"
                  onClick={() => handleCheckboxChange(member.Email)}
                />
                <span>
                  {member.First_Name} {member.Last_Name}
                </span>
              </div>
          ))}

          {activeTab === "Project" && rowsToDisplay.map((item, index) => {
                  const name = item.name || item.address;
              return (
              <div className="team-member" key={item.id || index}>
                <img
                  src={
                    selectedMembers[item.id]
                      ? "../images/checkbox-checked.png"
                      : "../images/checkbox-unchecked.png"
                  }
                  alt={selectedMembers[item.id] ? "Checked" : "Unchecked"}
                  className="member-icon"
                  onClick={() => handleCheckboxChange(item.id)}
                />
                <span>{name}</span>
              </div>
              );
          })}
        </div>

      </div>

        <div className="timesheet-header-container">
          <div className="timesheet-header">
            {view !== 'Month' ? (
              <select className="month-dropdown" value={selectedMonth} onChange={(e) => handleMonthChange(e.target.value)}>
                {months.map((month) => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
            ) : (
              <select className="year-dropdown" value={selectedYear} onChange={handleYearChange}>
              {years.map((year) => (
                  <option key={year} value={year}>{year}</option>
              ))}
          </select>
            )}
            <div className="view-toggle">
              <button 
                className={`toggle-button ${view === 'Day' ? 'active' : ''}`} 
                onClick={() => handleViewChange('Day')}
              >
                Day
              </button>
              <button 
                className={`toggle-button ${view === 'Week' ? 'active' : ''}`} 
                onClick={() => handleViewChange('Week')}
              >
                Week
              </button>
              <button 
                className={`toggle-button ${view === 'Month' ? 'active' : ''}`} 
                onClick={() => handleViewChange('Month')}
              >
                Month
              </button>
            </div>
          </div>

          <div className="period-selection">
            {view === 'Day' && (
              <>
                <button className="scroll-arrow" onClick={() => scrollDays(-1)}>&#9664;</button>
                {days.slice(currentDayIndex, currentDayIndex + 15).map(day => ( 
                  <div key={day} className="period">{day}</div>
                ))}
                <button className="scroll-arrow" onClick={() => scrollDays(1)}>&#9654;</button>
              </>
            )}

            {view === 'Week' && (
              <>
                <button className="scroll-arrow" onClick={() => scrollWeeks(-1)}>&#9664;</button>
                {weeks.slice(currentWeekIndex, currentWeekIndex + 4).map((week, index) => (
                  <div key={index} className="period" title={week}>{week}</div> // Add title for hover tooltip
                ))}
                <button className="scroll-arrow" onClick={() => scrollWeeks(1)}>&#9654;</button>
              </>
            )}

            {view === 'Month' && (
              <div className="months-list">
                <button onClick={() => scrollMonths(-1)} className="scroll-arrow">&#9664;</button>
                {months.slice(currentMonthIndex, currentMonthIndex + 10).map((month) => (
                  <div key={month} className="period"  onClick={() => handleMonthChange(month)} 
                    onContextMenu={(e) => {
                      e.preventDefault(); 
                      handleMonthChange(month); // Handle the right-click to change month
                    }}
                    tabIndex={0} // Make it focusable for accessibility
                    onKeyDown={(e) => { if (e.key === 'Enter') { handleMonthChange(month);}}} 
                  >
                    {month}
                  </div>
                ))}
                <button onClick={() => scrollMonths(1)} className="scroll-arrow">&#9654;</button>
              </div>
            )}

          </div>

          <table className="timesheet-table">
            <thead>
              <tr>
                <th> <img src="/images/servicecall.svg" alt="Service Call Icon" className="label-icon" /> Name </th>
                <th> <img src="/images/date.png" alt="Date Icon" className="label-icon" /> Date </th>
                <th> <img src="/images/worker.png" alt="Time Icon" className="label-icon" /> Type </th>
                <th> <img src="/images/time.png" alt="Tasks Icon" className="label-icon" /> Hours </th>
                <th> <img src="/images/status.svg" alt="Type Icon" className="label-icon" /> Status </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rowsToDisplay.map((item, index) => {
                const type = item.hours && !item.status ? "Project" : "Service Call"; 

                return (
                  <tr key={index}>
                    <td><b>{item.name || item.address}</b></td>
                    <td>{new Date(item.date).toLocaleDateString()}</td>
                    <td>{type}</td>
                    <td>{item.hours || "N/A"}</td>
                    <td>
                      {item.status === "Completed" ? (
                        <img
                          src="images/complete.svg"
                          alt="Completed"
                          style={{ marginRight: "5px" }}
                          className="status-icon"
                        />
                      ) : (
                        <img src="/images/inprogress.svg" alt="In Progress" style={{ marginRight: "5px" }} className="status-icon" />
                      )}
                      <span
                        className="status-text"
                        style={{
                          color: item.status === "Completed" ? "#8ABE14" : "#E59A0A",
                        }}
                      >
                        {item.status || "In Progress"}
                      </span>
                    </td>
                    
                    <td>
                      <button onClick={() => redirectToTimesheetDetails(item.id, type)}>
                        <img src="/images/arrow.png" alt="Next Icon" className="next-icon"/>
                      </button>
                    </td>

                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      </div>
      
      <div className="pagination">
            {renderPageNumbers()}
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="pagination-next" >
              Next </button>
      </div>

      <div className="button-section">
        <button className="export-button" > Export Excel </button>
        <button className="download-button" >Download Pdf </button>
      </div>

      <Footer />

    </div>
  );
};

export default TimeSheets;
